import api from "../atlasApi";

export const serviceSaveLayer = (data) => {
  return api.post("/horizon/add-edit-delete-layer/", data, {
    headers: {
      Authorization: "Token ea0bb95d88829a5174bae4657242c5c48e121228",
      "Content-Type": "multipart/form-data",
    },
  });
};

export const serviceGetLayerFromPostgreSQL = (data) => {
  return api.post("/horizon/spatial-query/", data, {
    headers: {
      Authorization: "Token ea0bb95d88829a5174bae4657242c5c48e121228",
      "Content-Type": "multipart/form-data",
    },
  });
};

export const serviceAddEditPostgreSQL = (data, token) => {
  return api.post("/horizon/add-edit-database-record/", data, {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const serviceGetLayerFromServer = (data) => {
  return api.post("/horizon/get-layer/", data, {
    headers: {
      Authorization: "Token ea0bb95d88829a5174bae4657242c5c48e121228",
      "Content-Type": "multipart/form-data",
    },
  });
};
